import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  passwordFormWrapper: {
    padding: theme.spacing(0, 50),
    boxSizing: 'content-box',

    [theme.breakpoints.down('sm')]: {
      boxSizing: 'border-box',
      padding: theme.spacing(25, 50),
    },

    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(20, 26),
    },
  },
}));
